import CertificateApi from '@/api/warehouse/certificate/CertificateApi'
import { createBaseController } from '@/controllers/baseController'
import { createBaseFileController } from '@/controllers/baseFileController'
import { createBaseResponseErrors, createFilesResponseErrors } from '@/utils/error/responseErrors'
import { setAlertError } from '@/utils/store/alert'

const CERTIFICATE_ERRORS = {
  ...createBaseResponseErrors('сертификат', 'сертификатов'),
  ...createFilesResponseErrors(),
  addFiles: 'Не удалось добавить файлы',
  changeFile: 'Не удалось заменить файл',
  update: 'Не удалось отредактировать сертификат',
  delete: 'Не удалось удалить сертификат'
}

export default {
  ...createBaseController(CertificateApi, CERTIFICATE_ERRORS),
  ...createBaseFileController(CertificateApi, CERTIFICATE_ERRORS),

  /*
  * Добавление файлов сертификата
  * */
  addFilesCertificate: async (id, data) => {
    try {
      return await CertificateApi.addFilesCertificate(id, data)
    } catch (e) {
      await setAlertError(e, CERTIFICATE_ERRORS.addFiles)
    }
  },

  /*
  * Замена файла сертификата
  * */
  changeFile: async (id, data) => {
    try {
      return await CertificateApi.changeFile(id, data)
    } catch (e) {
      await setAlertError(e, CERTIFICATE_ERRORS.changeFile)
    }
  },

  /*
  * Редактирование сертификата (name и d_wires)
  * */
  update: async (data) => {
    try {
      return await CertificateApi.update(data)
    } catch (e) {
      await setAlertError(e, CERTIFICATE_ERRORS.update)
    }
  },

  /*
  * Удаление сертификата (name и d_wires)
  * */
  delete: async (data) => {
    try {
      return await CertificateApi.delete(data)
    } catch (e) {
      await setAlertError(e, CERTIFICATE_ERRORS.delete)
    }
  }
}
